export default {
  BUTTON_PRIMARY_CLASS: 'button button--primary',
  BUTTON_SECONDARY_CLASS: 'button',

  VEHICLE_WIDGET_COLLAPSIBLE_CLASS: 'home-featured home-content',
  CHANGE_VEHICLE: 'Change',
  DISCARD_VEHICLE: 'Clear',

  SEARCH_BOX_CLASS: 'form',
  SEARCH_BOX_INPUT_CLASS: 'form-input',
  SEARCH_BOX_BUTTON_CLASS: 'form-button',
  SEARCH_BOX_PLACEHOLDER: 'Search the store',

  GARAGE_SIZE: '<span class="garage-size countPill  countPill--positive" key="garage-size">{{size}}</span>',
  GARAGE_TITLE: '',
};
